import callApi from "./callApi";

export default {
  ...callApi,
  resetPagination: ({ commit }) => {
    commit("resetPagination");
  },
  setCashWithdraw: ({ commit }, payload) => {
    commit("setCashWithdraw", payload);
  },
  resetWithdrawHistory: ({ commit }) => {
    commit("resetWithdrawHistory");
  },
  resetAfiliated: ({ commit }) => {
    commit("resetAfiliated");
  },
  resetMutasiSaldo: ({ commit }) => {
    commit("resetMutasiSaldo");
  },
  setResponse:({commit}, payload) => {
    commit("setResponse", payload);
  },
  resetCountData:({ commit }) => {
    commit("setAfiliatedTotal", { totalData : 0 });
  }
};
